export default __webpack_public_path__ + "static/media/setkeeper.0b50696b.png";